import { Editor } from 'slate';
import { isMarkActive } from '../helpers';
import { MarkType } from '../types';

export const toggleMark = (editor: Editor, markType: MarkType): void =>
	isMarkActive(editor, markType)
		? editor.removeMark(markType)
		: editor.addMark(markType, true);
